import React from 'react';

export const ClientUserIdContext = React.createContext<string | undefined>(undefined);
